<template>
  <!-- If `visible` prop is provided, use it. Otherwise (undefined) render when parent mounts the component (v-if). -->
  <div v-if="visible ?? true" class="confirm-dialog-overlay">
    <div class="confirm-dialog-content">
      <h3 class="text-lg font-semibold mb-2">{{ title }}</h3>
      <p class="mb-4">{{ message }}</p>
      <div class="flex space-x-2 justify-end">
        <button class="btn-secondary" @click="$emit('cancel')">No</button>
        <button class="btn-primary" @click="$emit('confirm')">Yes</button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
// typed props and emits for the confirm dialog
defineProps<{ title: string; message: string; visible?: boolean }>()
defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()
</script>
<style scoped>
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.confirm-dialog-content {
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  min-width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
</style>
